const qrCodes = {
  helpers: {
    content: "Enter valid URL format ex: https://www.autura.com",
  },
  findMyCar: {
    label: "Find My Car",
    title: "Find My Car QR Code and Link",
    action_title: "Generate Find My Car QR code Link",

    message:
      "You can provide the following QR Code or Link to help find vehicles towed from this property",
  },
};

export default qrCodes;
